import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImage from './images/sipc-desktop.svg';
// styles
import { InformationalModuleStyled } from './styles';

export default () => {
  return (
    <InformationalModuleStyled
      // configs
      sectionId='investment-account-protection-financial-planning-1'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>SIPC protection for your Northwestern <WidowBlock>Mutual investments</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            While all investments carry the risk of the loss of principal, rest assured that if something happens to Northwestern Mutual, you&#39;re covered. That&#39;s because Northwestern Mutual Investment Services Company (NMIS) is a member of&nbsp;
            <Link
              variant='primaryDeemphasize'
              linkUrl='https://www.sipc.org/'
              isOutgoingLink>
              Securities Investor Protection Corporation (SIPC)
            </Link>. SIPC protects NMIS accounts up to &#36;500,000 (including &#36;250,000 for claims for cash) in the event that a firm fails.
          </Typography>
          <BulletedList
            bulletedListData={[
              {
                bulletText: (
                  <>
                    <Typography
                      component='span'
                      variant='h4'
                      nextElement='typography'
                      weight={500}
                      block>
                      Protection beyond SIPC
                    </Typography>
                    <Typography
                      component='span'
                      nextElement='typography'>
                      NMIS&#39;s accounts are held through its{' '}
                      <Link
                        variant='primaryDeemphasize'
                        linkUrl='https://www.finra.org/arbitration-mediation/overview/additional-resources/faq/clearing-firms/'
                        ariaLabel='FINRA clearing firm'
                        isOutgoingLink>
                        clearing firm
                      </Link>
                      , <WidowBlock>Pershing LLC,</WidowBlock> which provides additional protection for assets held in its custody. Pershing&#39;s additional account balance coverage through Lloyd&#39;s of London and other third&#45;party commercial insurers may provide benefits beyond what&#39;s covered by SIPC. Please reach out to your financial advisor if you have questions about coverage for your Northwestern Mutual investment account.
                    </Typography>
                  </>
                ),
              },
              {
                bulletText: (
                  <>
                    <Typography
                      component='span'
                      variant='h4'
                      nextElement='typography'
                      weight={500}
                      block>
                      Protection for multiple accounts
                    </Typography>
                    <Typography component='span'>
                      Each account you have with NMIS in which you act in a different capacity is SIPC protected. This means that if you act as sole owner of one account and custodian of another, each of those accounts retains separate SIPC protection.
                    </Typography>
                  </>
                ),
              },
            ]}
            bulletType='checkmark'
            themeType= 'lightTheme'
          />
        </>
      )}
      // image props
      imageAltText='SIPC Protection up to five hundred thousand dollars.'
      imageSrcDefault={financialPlanningImage}
    />
  );
};

